import { VenuesState } from "./venues.types";

const state = (): VenuesState => ({
  data: {},
  filters: {}
})

export default state
